import { RuleParameterSchemaItem, RuleParameterValues } from '../types';

export function parseParameterSchema(paramsValue?: string | null): RuleParameterSchemaItem[] {
  if (!paramsValue) return [];

  const parsed = JSON.parse(paramsValue);
  if (!Array.isArray(parsed)) throw new Error('The selected rule has an invalid parameter schema.');

  return parsed.map((item) => {
    if (!item || typeof item.id !== 'string' || typeof item.type !== 'string') {
      throw new Error('The selected rule contains an unsupported parameter definition.');
    }
    return {
      label: item.label || '',
      id: item.id,
      type: item.type,
      optionsSource: item.optionsSource ?? null,
      required: Boolean(item.required),
      removeTrim: Boolean(item.removeTrim),
      defaultValue: item.defaultValue,
      inline: Boolean(item.inline),
      placeholder: item.placeholder,
      validationType: item.validationType,
      validations: item.validations,
      ruleTypeCode: item.ruleTypeCode,
      allowEmpty: item.allowEmpty,
      customRegex: item.customRegex,
      customRegexErrorMessage: item.customRegexErrorMessage,
    };
  });
}

export function createInitialParameterValues(schema: RuleParameterSchemaItem[]): RuleParameterValues {
  return schema.reduce<RuleParameterValues>((values, field) => {
    values[field.id] = field.defaultValue ?? (field.type === 'switch-toggle' ? 'false' : '');
    return values;
  }, {});
}

export function expandDynamicParameterSchema(
  schema: RuleParameterSchemaItem[],
  savedParameterCount: number
): RuleParameterSchemaItem[] {
  if (savedParameterCount <= schema.length || !schema.some((field) => field.type === 'dropdown-dynamic')) {
    return schema;
  }

  const template = schema.find((field) => field.type === 'dropdown-dynamic');
  if (!template) return schema;

  const expanded = [...schema];
  for (let index = schema.length; index < savedParameterCount; index += 1) {
    expanded.push({
      ...template,
      id: `ATTRIBUTE${index + 1}`,
      label: `Attribute ${index + 1}`,
      required: false,
      defaultValue: '',
    });
  }
  return expanded;
}
